import React, { useEffect, useState } from 'react'
import { ElectricCatgory } from './ElectricCategory/ElectricCatgory'
import { CategoryGrid } from './CategoryGrid'
import { Deal } from './Deal/Deal'
import { ShopByCategory } from './ShopByCategory/ShopByCategory'
import { SellerImage } from './SellerImage/SellerImage'
import { useMediaQuery, useTheme } from '@mui/material'
import { useAppDispatch } from '../../../State/Store'
import { createHomeCategories } from '../../../State/admin/adminSlice'
import { homeCategories } from '../../data/homeCategories'
// const width = window.innerWidth; is executed only when the component is initially rendered.
// The width value will not change unless the component is re-rendered for other reasons (like a state or prop change unrelated to window size).

export const Home = () => {
  
  const theme = useTheme();
  const isLarge = useMediaQuery(theme.breakpoints.up("lg"));
   const [width, setWidth] = useState(window.innerWidth);
   const dispatch = useAppDispatch()
   useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    // dispatch(createHomeCategories(homeCategories));
    // Cleanup the event listener on component unmount
    return () => window.removeEventListener("resize", handleResize);
  }, [dispatch]);

  return (
    <>
    <div    className={`m-0 lg:space-y-16 relative ${
        width >= 2700 ? "mx-[20%]" : "mx-auto"
      }`}>
     {isLarge?(<ElectricCatgory/>):(<></>)} 
      <CategoryGrid/>
      <Deal/>
      <SellerImage/>
      <ShopByCategory/>
      
    </div>
    </>
  )
}
